export default __webpack_public_path__ + "static/media/illustration_literature.8d242b25.png";